/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_Logo_AltInputs */

const en_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Logo`)
};

const fr_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo du systeme`)
};

const de_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systemlogo`)
};

const it_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo del sistema`)
};

const ru_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип системы`)
};

const es_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo del sistema`)
};

const zh_cn2_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统标志`)
};

const ja_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システムロゴ`)
};

const hi_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिस्टम लोगो`)
};

const pt_pt2_system_logo_alt = /** @type {(inputs: System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo do sistema`)
};

/**
* | output |
* | --- |
* | "System Logo" |
*
* @param {System_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const system_logo_alt = /** @type {((inputs?: System_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_system_logo_alt(inputs)
	if (locale === "de") return de_system_logo_alt(inputs)
	if (locale === "it") return it_system_logo_alt(inputs)
	if (locale === "ru") return ru_system_logo_alt(inputs)
	if (locale === "es") return es_system_logo_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_system_logo_alt(inputs)
	if (locale === "ja") return ja_system_logo_alt(inputs)
	if (locale === "hi") return hi_system_logo_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_system_logo_alt(inputs)
	return en_system_logo_alt(inputs)
});